export const corePhraseGroups = [
  {
    id: 'greetings',
    title: 'Greetings & Social',
    phrases: [
      { english: 'Hello', mandarin: 'nǐ hǎo / nín hǎo', spoken: '你好' },
      { english: 'Hi there', mandarin: 'nǐ hǎo ya / nín hǎo', spoken: '你好' },
      { english: 'Good morning', mandarin: 'zǎoshang hǎo', spoken: '早上好' },
      { english: 'Good afternoon', mandarin: 'xiàwǔ hǎo', spoken: '下午好' },
      { english: 'Good evening', mandarin: 'wǎnshang hǎo', spoken: '晚上好' },
      { english: 'Nice to meet you', mandarin: 'hěn gāoxìng rènshi nǐ / nín', spoken: '很高兴认识你' },
      { english: 'How are you', mandarin: 'nǐ hǎo ma / nín hǎo ma', spoken: '你好吗' },
      { english: 'I’m fine, thanks', mandarin: 'wǒ hěn hǎo, xièxie', spoken: '我很好，谢谢' },
      { english: 'See you later', mandarin: 'huítóu jiàn', spoken: '回头见' },
      { english: 'Take care', mandarin: 'bǎozhòng', spoken: '保重' },
    ],
  },
  {
    id: 'politeness',
    title: 'Politeness',
    phrases: [
      { english: 'Please', mandarin: 'qǐng', spoken: '请' },
      { english: 'Thank you', mandarin: 'xièxie', spoken: '谢谢' },
      { english: 'You’re welcome', mandarin: 'bú kèqi', spoken: '不客气' },
      { english: 'Excuse me', mandarin: 'qǐng wèn / bù hǎo yìsi', spoken: '不好意思' },
      { english: 'I’m sorry', mandarin: 'duìbuqǐ / bù hǎo yìsi', spoken: '对不起' },
      { english: 'No problem', mandarin: 'méi wèntí', spoken: '没问题' },
      { english: 'That’s okay', mandarin: 'méi guānxi', spoken: '没关系' },
    ],
  },
  {
    id: 'needs',
    title: 'Basic Needs',
    phrases: [
      { english: 'I need help', mandarin: 'wǒ xūyào bāngzhù', spoken: '我需要帮助' },
      { english: 'Can you help me', mandarin: 'nǐ/nín néng bāng wǒ ma', spoken: '你能帮我吗' },
      { english: 'Can you repeat that', mandarin: 'nǐ/nín néng zài shuō yí biàn ma', spoken: '你能再说一遍吗' },
      { english: 'I don’t understand', mandarin: 'wǒ bù dǒng', spoken: '我不懂' },
      { english: 'What does this mean', mandarin: 'zhè shì shénme yìsi', spoken: '这是什么意思' },
      { english: 'How much is this', mandarin: 'zhège duōshao qián', spoken: '这个多少钱' },
      { english: 'Where is the bathroom', mandarin: 'cèsuǒ zài nǎlǐ', spoken: '厕所在哪里' },
      { english: 'I’m looking for…', mandarin: 'wǒ zài zhǎo…', spoken: '我在找东西' },
      { english: 'Can I have this', mandarin: 'wǒ kěyǐ yào zhège ma', spoken: '我可以要这个吗' },
      { english: 'I’d like to order…', mandarin: 'wǒ xiǎng diǎn…', spoken: '我想点这个' },
    ],
  },
  {
    id: 'daily',
    title: 'Daily Conversation',
    phrases: [
      { english: 'What’s your name', mandarin: 'nǐ jiào shénme míngzi / nín guìxìng', spoken: '你叫什么名字' },
      { english: 'My name is…', mandarin: 'wǒ jiào…', spoken: '我叫' },
      { english: 'Where are you from', mandarin: 'nǐ shì nǎlǐ rén / nín shì nǎlǐ rén', spoken: '你是哪里人' },
      { english: 'I’m from…', mandarin: 'wǒ shì… rén', spoken: '我是这里人' },
      { english: 'What do you do', mandarin: 'nǐ zuò shénme gōngzuò / nín ne', spoken: '你做什么工作' },
      { english: 'I work in…', mandarin: 'wǒ zài… gōngzuò', spoken: '我在工作' },
      { english: 'That’s interesting', mandarin: 'zhēn yǒu yìsi', spoken: '真有意思' },
      { english: 'Really', mandarin: 'zhēn de ma', spoken: '真的吗' },
      { english: 'I agree', mandarin: 'wǒ tóngyì', spoken: '我同意' },
      { english: 'I disagree', mandarin: 'wǒ bù tóngyì', spoken: '我不同意' },
    ],
  },
  {
    id: 'time',
    title: 'Time & Scheduling',
    phrases: [
      { english: 'What time is it', mandarin: 'xiànzài jǐ diǎn', spoken: '现在几点' },
      { english: 'When does it start', mandarin: 'shénme shíhou kāishǐ', spoken: '什么时候开始' },
      { english: 'I’m running late', mandarin: 'wǒ yào chídào le', spoken: '我要迟到了' },
      { english: 'Let’s go', mandarin: 'wǒmen zǒu ba', spoken: '我们走吧' },
      { english: 'Let’s begin', mandarin: 'wǒmen kāishǐ ba', spoken: '我们开始吧' },
      { english: 'One moment, please', mandarin: 'qǐng shāo děng', spoken: '请稍等' },
    ],
  },
  {
    id: 'feelings',
    title: 'Feelings',
    phrases: [
      { english: 'I like it', mandarin: 'wǒ xǐhuan', spoken: '我喜欢' },
      { english: 'I don’t like it', mandarin: 'wǒ bù xǐhuan', spoken: '我不喜欢' },
      { english: 'That’s great', mandarin: 'tài hǎo le', spoken: '太好了' },
      { english: 'That’s not good', mandarin: 'nà bù hǎo', spoken: '那不好' },
      { english: 'I’m tired', mandarin: 'wǒ lèi le', spoken: '我累了' },
      { english: 'I’m hungry', mandarin: 'wǒ è le', spoken: '我饿了' },
      { english: 'I’m busy', mandarin: 'wǒ hěn máng', spoken: '我很忙' },
    ],
  },
];
